import useEventListeners from './useEventListeners';

const FinanceData = () => {
  useEventListeners();

  return null;
};

export default FinanceData;
